import { erroPeriodoConsulta } from '../../core/tools/periodo-consulta';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';

import { PedidoService, PedidoStatsResult, PedidoStatsUnificadoRequest, PedidosPagedRequest, PagedResult } from '../../core/services/pedidos/pedido.service';
import { RelatoriosService, ExportarPedidosRequest } from '../../core/services/relatorios/relatorios.service';
import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { PedidoSintetico } from '../../core/models/pedidos/pedido-sintetico';

@Component({
    selector: 'app-pedidos-relatorios',
    templateUrl: './pedidos-relatorios.component.html',
    styleUrls: ['./pedidos-relatorios.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})
export class PedidosRelatoriosComponent implements OnInit {
  erroPeriodo = '';
  @Input() configuracao: Configuracao;

  formFiltro: UntypedFormGroup;
  gerandoStats: boolean = false;
  excelExportando: boolean = false;
  stats: PedidoStatsResult = null;
  estatisticas: any[] = [];

  pedidos: PedidoSintetico[] = [];
  carregandoPedidos: boolean = false;
  page: number = 1;
  pageSize: number = 20;
  totalPages: number = 0;
  totalItems: number = 0;

  modelo_tela_ligacoes: number = parseInt(localStorage.getItem('modelo_tela_ligacoes')) || 0;

  telaOpcoes = [
    { texto: 'Atenção',      valor: 'ATENCAO'     },
    { texto: 'Enviados',     valor: 'ENVIADOS'     },
    { texto: 'Não Enviados', valor: 'NAO_ENVIADOS' },
    { texto: 'Pendências',   valor: 'PENDENCIAS'   },
    { texto: 'Pontuações',   valor: 'PONTUACOES'   }
  ];

  filtroOpcoes = [
    { texto: 'Período', valor: 1 },
    { texto: 'Cliente', valor: 2 },
    { texto: 'Nro Pedido', valor: 3 },
    { texto: 'Status', valor: 4 },
    { texto: 'Nro NF', valor: 5 },
    { texto: 'Dt Faturamento', valor: 6 }
  ];

  filtroStatus = [
    { texto: 'Faturado', valor: 'Faturado' },
    { texto: 'Integrado', valor: 'Integrado' },
    { texto: 'Faturado Div', valor: 'Faturado Div' },
    { texto: 'Cancelado', valor: 'Cancelado' },
    { texto: 'À Integrar', valor: 'À Integrar' },
    { texto: 'Aguard Financeiro', valor: 'Aguard Financeiro' },
    { texto: 'Aguard Gerencial', valor: 'Aguard Gerencial' },
    { texto: 'Aguard Diretor', valor: 'Aguard Diretor' },
    { texto: 'Aguard Coordenador', valor: 'Aguard Coordenador' },
    { texto: 'Aguard Cad', valor: 'Aguard Cad' },
    { texto: 'Erro Integ', valor: 'Erro Integ' },
    { texto: 'Reprovado', valor: 'Reprovado' }
  ];

  private statusClassMap: { [key: string]: string } = {
    'Faturado': 'badge-success',
    'Integrado': 'badge-info',
    'Faturado Div': 'badge-other',
    'Cancelado': 'badge-distinct',
    'À Integrar': 'badge-primary',
    'Aguard Financeiro': 'badge-financeiro',
    'Aguard Gerencial': 'badge-gerencial',
    'Aguard Diretor': 'badge-diretor',
    'Aguard Coordenador': 'badge-coordenador',
    'Aguard Cad': 'badge-secondary',
    'Erro Integ': 'badge-danger',
    'Reprovado': 'badge-dark'
  };

  constructor(
    private fb: UntypedFormBuilder,
    private pedidoService: PedidoService,
    private relatoriosService: RelatoriosService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.formFiltro = this.fb.group({
      tela: ['ENVIADOS', Validators.required],
      filtro: [1],
      dt_inicial: [null],
      dt_final: [null],
      vendedor: [''],
      cliente: [''],
      nro_pedido: [null],
      status: [''],
      nro_nf: [''],
      dt_fat_inicial: [null],
      dt_fat_final: [null]
    });
  }

  get f() { return this.formFiltro.controls; }

  get usaLitragem(): boolean {
    return this.configuracao != null && this.configuracao.pedido_exibir_litragem;
  }

  get valorTicketMedio(): number {
    if (!this.stats || this.stats.qtdePedidos === 0) return 0;
    return this.usaLitragem
      ? this.stats.litragemTotal / this.stats.qtdePedidos
      : this.stats.valorVendas / this.stats.qtdePedidos;
  }

  alterarFiltro(valor: number) {
    this.formFiltro.patchValue({ filtro: +valor, cliente: '', nro_pedido: null, status: '', nro_nf: '', dt_fat_inicial: null, dt_fat_final: null });
  }

  private calcularDados(stats: PedidoStatsResult) {
    if (!stats) { this.estatisticas = []; return; }
    const backendMap: { [key: string]: any } = {};
    (stats.statusStats || []).forEach(s => backendMap[s.status_pedido] = s);

    this.estatisticas = Object.keys(this.statusClassMap).map(status => {
      const s = backendMap[status];
      return {
        item: this.statusClassMap[status],
        descricao: status,
        valor: s ? s.valor : 0,
        valor_litragem: s ? s.litragem : 0,
        porcentagem: stats.valorVendas > 0 && s ? (s.valor / stats.valorVendas) * 100 : 0
      };
    });
  }

  private formatDate(raw: any): string | null {
    if (!raw || !raw.year) return null;
    return `${raw.year}-${String(raw.month).padStart(2, '0')}-${String(raw.day).padStart(2, '0')}`;
  }

  exportarExcel() {
    const faturamento = +this.f.filtro.value === 6;
    this.erroPeriodo = erroPeriodoConsulta(faturamento ? this.f.dt_fat_inicial.value : this.f.dt_inicial.value,
      faturamento ? this.f.dt_fat_final.value : this.f.dt_final.value, true);
    if (this.erroPeriodo) return;
    if (this.excelExportando) return;
    this.excelExportando = true;

    const filtro = +this.f.filtro.value;
    const payload: ExportarPedidosRequest = {
      userId: parseInt(localStorage.getItem('id'), 10),
      tipoRelatorio: 'GERAL',
      tela: this.f.tela.value,
      dataInicio: filtro !== 6 ? this.formatDate(this.f.dt_inicial.value) : null,
      dataFim: filtro !== 6 ? this.formatDate(this.f.dt_final.value) : null,
      vendedor: this.f.vendedor.value || null,
      cliente: filtro === 2 ? (this.f.cliente.value || null) : null,
      nroPedido: filtro === 3 ? (this.f.nro_pedido.value || null) : null,
      status: filtro === 4 ? (this.f.status.value || null) : null,
      numeroNf: filtro === 5 ? (this.f.nro_nf.value || null) : null,
      dtFaturamentoInicio: filtro === 6 ? this.formatDate(this.f.dt_fat_inicial.value) : null,
      dtFaturamentoFim: filtro === 6 ? this.formatDate(this.f.dt_fat_final.value) : null
    };

    this.relatoriosService.exportarExcel(payload).subscribe(
      blob => {
        if (blob) {
          const tela = payload.tela.toLowerCase();
          const sufixo = payload.dataInicio
            ? `${payload.dataInicio.replace(/-/g, '')}_${(payload.dataFim || '').replace(/-/g, '')}`
            : new Date().toISOString().slice(0, 10).replace(/-/g, '');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `pedidos-${tela}_${sufixo}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      () => { this.excelExportando = false; },
      () => { this.excelExportando = false; }
    );
  }

  exportarPontuacoes() {
    const faturamento = +this.f.filtro.value === 6;
    this.erroPeriodo = erroPeriodoConsulta(faturamento ? this.f.dt_fat_inicial.value : this.f.dt_inicial.value,
      faturamento ? this.f.dt_fat_final.value : this.f.dt_final.value, true);
    if (this.erroPeriodo) return;
    if (this.excelExportando) return;
    this.excelExportando = true;

    const filtro = +this.f.filtro.value;
    const payload: ExportarPedidosRequest = {
      userId: parseInt(localStorage.getItem('id'), 10),
      tipoRelatorio: 'GERAL',
      tela: 'ENVIADOS',
      dataInicio: filtro !== 6 ? this.formatDate(this.f.dt_inicial.value) : null,
      dataFim:    filtro !== 6 ? this.formatDate(this.f.dt_final.value)   : null,
      vendedor: this.f.vendedor.value || null,
      cliente:  filtro === 2 ? (this.f.cliente.value || null) : null,
      nroPedido: filtro === 3 ? (this.f.nro_pedido.value || null) : null,
      status:   filtro === 4 ? (this.f.status.value || null) : null,
      numeroNf: filtro === 5 ? (this.f.nro_nf.value || null) : null,
      dtFaturamentoInicio: filtro === 6 ? this.formatDate(this.f.dt_fat_inicial.value) : null,
      dtFaturamentoFim:    filtro === 6 ? this.formatDate(this.f.dt_fat_final.value)   : null
    };

    this.relatoriosService.exportarPontuacoesExcel(payload).subscribe(
      blob => {
        if (blob) {
          const sufixo = payload.dataInicio
            ? `${payload.dataInicio.replace(/-/g, '')}_${(payload.dataFim || '').replace(/-/g, '')}`
            : new Date().toISOString().slice(0, 10).replace(/-/g, '');
          const url = window.URL.createObjectURL(blob);
          const a   = document.createElement('a');
          a.href     = url;
          a.download = `pontuacoes_${sufixo}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      () => { this.excelExportando = false; },
      () => { this.excelExportando = false; }
    );
  }

  private buildPagedRequest(pg: number): PedidosPagedRequest {
    const filtro = +this.f.filtro.value;
    return {
      page: pg,
      pageSize: this.pageSize,
      sort: 'order_sent_on',
      direction: 'desc',
      dataInicio: filtro !== 6 ? this.formatDate(this.f.dt_inicial.value) : null,
      dataFim: filtro !== 6 ? this.formatDate(this.f.dt_final.value) : null,
      vendedor: this.f.vendedor.value || null,
      cliente: filtro === 2 ? (this.f.cliente.value || null) : null,
      nroPedido: filtro === 3 ? (this.f.nro_pedido.value || null) : null,
      status: filtro === 4 ? (this.f.status.value || null) : null,
      numeroNf: filtro === 5 ? (this.f.nro_nf.value || null) : null,
      dtFaturamentoInicio: filtro === 6 ? this.formatDate(this.f.dt_fat_inicial.value) : null,
      dtFaturamentoFim: filtro === 6 ? this.formatDate(this.f.dt_fat_final.value) : null
    };
  }

  get podeListar(): boolean {
    const tela = this.f.tela.value;
    return tela === 'ENVIADOS' || tela === 'ATENCAO';
  }

  carregarPedidos(pg: number = 1) {
    const faturamento = +this.f.filtro.value === 6;
    this.erroPeriodo = erroPeriodoConsulta(faturamento ? this.f.dt_fat_inicial.value : this.f.dt_inicial.value,
      faturamento ? this.f.dt_fat_final.value : this.f.dt_final.value, true);
    if (this.erroPeriodo) return;
    if (!this.podeListar) { this.pedidos = []; return; }
    this.carregandoPedidos = true;
    this.page = pg;

    const req = this.buildPagedRequest(pg);
    const tela = this.f.tela.value;
    const obs = tela === 'ATENCAO'
      ? this.pedidoService.getAtencaoPaged(req)
      : this.pedidoService.getEnviadosPaged(req);

    obs.subscribe(
      (result: PagedResult<PedidoSintetico>) => {
        this.pedidos = result.items || [];
        if (result.total != null) {
          this.totalItems = result.total;
          this.totalPages = Math.ceil(result.total / this.pageSize) || 1;
        } else {
          this.totalItems = 0;
          const hasMore = result.hasMore === true;
          this.totalPages = hasMore ? pg + 1 : pg;
        }
      },
      () => { this.carregandoPedidos = false; },
      () => { this.carregandoPedidos = false; }
    );
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.carregarPedidos(1);
  }

  gerarEstatisticas() {
    const faturamento = +this.f.filtro.value === 6;
    this.erroPeriodo = erroPeriodoConsulta(faturamento ? this.f.dt_fat_inicial.value : this.f.dt_inicial.value,
      faturamento ? this.f.dt_fat_final.value : this.f.dt_final.value, true);
    if (this.erroPeriodo) return;
    if (this.formFiltro.invalid || this.gerandoStats) return;
    if (this.f.tela.value === 'PONTUACOES') {
      this.toastr.info('Para Pontuações, clique diretamente em "Exportar Pontuações".');
      return;
    }

    this.gerandoStats = true;
    this.stats = null;
    this.estatisticas = [];
    this.pedidos = [];

    const filtro = +this.f.filtro.value;

    const req: PedidoStatsUnificadoRequest = {
      tela: this.f.tela.value,
      dataInicio: filtro !== 6 ? this.formatDate(this.f.dt_inicial.value) : null,
      dataFim: filtro !== 6 ? this.formatDate(this.f.dt_final.value) : null,
      vendedor: this.f.vendedor.value || null,
      cliente: filtro === 2 ? (this.f.cliente.value || null) : null,
      nroPedido: filtro === 3 ? (this.f.nro_pedido.value || null) : null,
      status: filtro === 4 ? (this.f.status.value || null) : null,
      numeroNf: filtro === 5 ? (this.f.nro_nf.value || null) as string : null,
      dtFaturamentoInicio: filtro === 6 ? this.formatDate(this.f.dt_fat_inicial.value) : null,
      dtFaturamentoFim: filtro === 6 ? this.formatDate(this.f.dt_fat_final.value) : null
    };

    this.pedidoService.getStatsUnificado(req).subscribe(
      result => {
        if (result === null) {
          this.toastr.error('Erro ao gerar estatísticas. Tente novamente.');
          this.stats = null;
          this.estatisticas = [];
          this.gerandoStats = false;
          return;
        }
        this.stats = result;
        this.calcularDados(result);
        this.carregarPedidos(1);
      },
      () => { this.stats = null; this.estatisticas = []; this.gerandoStats = false; },
      () => { this.gerandoStats = false; }
    );
  }
}
